



































































import Vue, { PropType } from "vue";
import { IofileJson, CsvParamJson, JsonObject } from "types/opts-json";
import OptsJsonUtil from "@/class/OptsJsonUtil";
import InputCsv from "@/components/end_parts/InputCsv.vue";

export default Vue.extend({
  components: {
    InputCsv,
  },
  props: {
    keyName: {
      // 文字列input
      type: String,
      default: String,
    },
    inputFileTransform: {
      // opts.jsonのtransform.convert以下を抽出したパラメータ
      type: String,
      default: String,
    },
    changeLanguage: {
      // 言語の設定パラメータ
      type: String,
      default: String,
    },
    paramJson: {
      // 親から受け取ったパラメータ
      type: Object,
      default: Object,
    },
    eventa: Boolean,
  },
  data() {
    return {
      keyMine: "",
      inputJson: {} as IofileJson,
      csvParamJson: {} as CsvParamJson,
      outputJson: {} as IofileJson,
      InputFileStr: "",
      inputFileSendstr: "",
      InputFileHeader: [""],
      InputFileNoHeader: [""],
      defaultHeader: [""],
      regexspace: new RegExp(
        /^-?(-?[0-9]*.?([0-9]*))( -?([0-9])*.?([0-9]*))*$/
      ), //区切り文字がスペースかどうかを判定する正規表現
      regexcomma: new RegExp(
        /^-?(-?[0-9]*.?([0-9]*))(,-?([0-9])*.?([0-9]*))*$/
      ), //区切り文字がカンマかどうかを判定する正規表現
      JsonParam: Object,
      InputPlaceholder: "",
      Reference: "",
      columnName: {
        "background-color": "#BAD3FF",
        padding: "10px",
        margin: "0px -15px",
        "border-top": "solid 1px #DDDDDD",
        "border-right": "solid 1px #DDDDDD",
        "border-bottom": "solid 1px #DDDDDD",
        "border-left": "solid 1px #DDDDDD",
      },
      columnCenter: {
        padding: "5px",
        margin: "0px -15px",
        "border-right": "solid 1px #DDDDDD",
        "border-left": "solid 1px #DDDDDD",
        "border-bottom": "solid 1px #DDDDDD",
      },
      column: {
        padding: "5px",
        margin: "0px -15px",
        "border-right": "solid 1px #DDDDDD",
        "border-bottom": "solid 1px #DDDDDD",
        "border-left": "solid 1px #DDDDDD",
      },
      file: null,
    };
  },
  watch: {
    // InputFileHeader() {
    //   if (this.csvParamJson.separator === ",") {
    // },
    paramJson: {
      handler() {
        this.reload();
        this.outputConsoleDisplay();
      },
      deep: true,
    },
    changeLanguage() {
      if (this.defaultHeader[0] === "1列目") {
        this.defaultHeader = [
          String(Vue.i18n.translate("opts.input.header.0")),
          String(Vue.i18n.translate("opts.input.header.1")),
          String(Vue.i18n.translate("opts.input.header.2")),
        ];
      }
      if (this.defaultHeader[0] === "First line") {
        this.defaultHeader = [
          String(Vue.i18n.translate("opts.input.header.0")),
          String(Vue.i18n.translate("opts.input.header.1")),
          String(Vue.i18n.translate("opts.input.header.2")),
        ];
      }
    },
  },
  updated() {
    this.reload();
  },
  created: function () {
    if (this.$store.state.inputFile.name === undefined) {
      this.keyMine = "opts." + this.keyName;
      this.defaultHeader = [
        String(Vue.i18n.translate("opts.input.header.0")),
        String(Vue.i18n.translate("opts.input.header.1")),
        String(Vue.i18n.translate("opts.input.header.2")),
      ];
      this.reload();
    } else {
      this.keyMine = "opts." + this.keyName;
      this.inputJson = this.paramJson[this.keyName] as IofileJson;
      this.csvParamJson = this.inputJson.parameter;
      this.outputConsoleDisplay();
    }
  },
  methods: {
    reload() {
      this.InputPlaceholder = String(
        Vue.i18n.translate(this.keyMine + ".input_placeholder")
      );
      this.Reference = String(Vue.i18n.translate(this.keyMine + ".reference"));
      if (
        this.keyName in this.paramJson &&
        OptsJsonUtil.isIofileJson(this.paramJson[this.keyName])
      ) {
        this.inputJson = this.paramJson[this.keyName] as IofileJson;
        this.csvParamJson = this.inputJson.parameter;
      }
    },
    saveFileObject(event: Event) {
      if (event.target instanceof HTMLInputElement) {
        this.inputJson["local_path"] = event.target.value;
        //this.paramJson[this.keyName] = this.inputJson
        if (event.target.files) {
          const file = event.target.files[0];
          this.$store.commit("setFile", file);
        }
        this.changeColumeHeader();
        this.outputConsoleDisplay();
      }
    },
    outputConsoleDisplay() {
      const file = this.$store.state.inputFile as File;
      if (file.name !== undefined) {
        const Reader = new FileReader();
        const Header: string[] = [];
        const noHeader: string[] = [];
        let linage = 0;
        let count = 0;
        let InputFile = "";
        const loadFunc = () => {
          if (typeof Reader.result === "string") {
            const lines = Reader.result.split(/\r\n|\n/);
            if (lines.length < 6) {
              linage = lines.length;
            } else {
              linage = 6;
            }
            this.chackSeparator(lines[0]);
            lines.forEach((element) => {
              if (count < linage) {
                const workerData = element.split(this.csvParamJson.separator);
                // if (workerData.length != 3) return;
                if (count < 1) {
                  for (let i = 0; i < workerData.length; i++) {
                    Header[i] = workerData[i];
                    noHeader[i] = String(i + 1);
                  }
                }
                for (let i = 0; i < workerData.length; i++) {
                  InputFile += workerData[i];
                  if (i < workerData.length - 1) {
                    InputFile += this.csvParamJson.separator;
                  }
                }
                if (count < linage - 1) {
                  InputFile += "\n";
                }
                count++;
              }
            });
            this.InputFileStr = InputFile;
            this.InputFileHeader = Header;
            this.InputFileNoHeader = noHeader;
            this.checkHeader();
            this.changeColume();
            this.$emit("InputFileSend", this.inputFileSendstr);
            if (this.csvParamJson.header === true) {
              this.utmCoordinateChange(this.inputFileSendstr, 1);
            } else {
              this.utmCoordinateChange(this.inputFileSendstr, 0);
            }
          }
        };
        Reader.onload = loadFunc;
        const blob = this.$store.state.inputFile.slice(0, 5000);
        Reader.readAsText(blob);
      }
    },
    pre() {
      if (this.InputFileStr === "") {
        this.$emit(
          "InputConsole",
          Vue.i18n.translate("opts.input.input_placeholder")
        );
        return;
      }
      const ConsoleStr = this.InputFileStr;
      this.$emit("InputConsole", ConsoleStr);
    },
    checkHeader() {
      if (this.InputFileHeader.length !== 1) {
        if (this.csvParamJson.header === true) {
          this.defaultHeader = this.InputFileHeader;
        }
        if (this.csvParamJson.header === false) {
          this.defaultHeader = this.InputFileNoHeader;
        }
      }
    },
    changeColumeHeader() {
      const file = this.$store.state.inputFile;
      const Reader = new FileReader();
      const loadFunc = () => {
        if (typeof Reader.result === "string") {
          const lines = Reader.result.split(/\r\n|\n/);
          this.chackSeparator(lines[0]);
          this.chackHeaderBoolean(lines[0]);
          const header = lines[0].split(this.csvParamJson.separator);
          const hintList = [
            ["Lon", "E", "X", "経度"],
            ["Lat", "N", "Y", "緯度"],
          ];
          for (let i = 0; i < header.length; i++) {
            for (let j = 0; j < hintList.length; j++) {
              for (let k = 0; k < hintList[j].length; k++) {
                if (
                  header[i].substr(0, hintList[j][k].length).toUpperCase() ===
                  hintList[j][k].toUpperCase()
                ) {
                  this.csvParamJson.columns[j] = i;
                  break;
                }
              }
            }
          }
        }
      };
      Reader.onload = loadFunc;
      Reader.readAsText(file);
    },
    changeColume() {
      let fileContent = "";
      const filteredData = this.InputFileStr.split(/\r\n|\n/);
      const splitDivert = filteredData.filter((item) => item.trim() !== "");
      if (splitDivert.length < 5) {
        for (let i = 0; i < splitDivert.length; i++) {
          const splitSeparator = splitDivert[i].split(
            this.csvParamJson.separator
          );
          const colNum = this.csvParamJson.columns.length;
          for (let j = 0; j < colNum; j++) {
            fileContent += splitSeparator[this.csvParamJson.columns[j]];
            if (j < colNum - 1) {
              fileContent += this.csvParamJson.separator;
            }
          }
          if (i < splitDivert.length - 1) {
            fileContent += "\n";
          }
        }
      } else {
        for (let i = 0; i < 6; i++) {
          const splitSeparator = splitDivert[i].split(
            this.csvParamJson.separator
          );
          for (let j = 0; j < 3; j++) {
            fileContent += splitSeparator[this.csvParamJson.columns[j]];
            if (j < 2) {
              fileContent += this.csvParamJson.separator;
            }
          }
          if (i < 5) {
            fileContent += "\n";
          }
        }
      }
      this.inputFileSendstr = fileContent;
    },
    chackHeaderBoolean(header: string) {
      if (this.csvParamJson.separator === ",") {
        if (this.regexcomma.test(header)) {
          this.csvParamJson.header = false;
          return;
        }
        this.csvParamJson.header = true;
      }
      if (this.csvParamJson.separator === " ") {
        if (this.regexspace.test(header)) {
          this.csvParamJson.header = false;
          return;
        }
        this.csvParamJson.header = true;
      }
      if (this.csvParamJson.separator === "\t") {
        if (this.regexspace.test(header)) {
          this.csvParamJson.header = false;
          return;
        }
        this.csvParamJson.header = true;
      }
    },
    inputFileParameter(changeKey: string, changeBoolean: boolean) {
      this.$emit("chackBoxEvent", changeKey, changeBoolean);
    },
    inputFileSeparator() {
      this.$emit("sendInputFileSeparator");
    },
    clearFiles() {
      this.file = null;
      this.$store.commit("setFile", {});
    },
    chackSeparator(tester: String) {
      if (tester.indexOf(",") >= 0) {
        this.csvParamJson.separator = ",";
        this.inputFileSeparator();
      } else if (tester.indexOf(" ") >= 0) {
        this.csvParamJson.separator = " ";
        this.inputFileSeparator();
      } else if (tester.indexOf("\t") >= 0) {
        this.csvParamJson.separator = "\t";
        this.inputFileSeparator();
      }
    },
    utmCoordinateChange(inputFile: string, header: number) {
      const lines = inputFile.split(/\r\n|\n/);
      const line = lines[header].split(this.csvParamJson.separator);
      let long = Number(line[0]);
      const mod = long % 6;
      let coordinate = long - mod;
      let count = coordinate / 6;
      if (count > 180 || count < -180) {
        return;
      }
      if (Number(line[1]) > 0) {
        this.paramJson.transform.projection.zone = String(count + 31) + "n";
      } else {
        this.paramJson.transform.projection.zone = String(count + 31) + "s";
      }
    },
  },
});
